import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import BookingConfirmation from './components/BookingConfirmation';
import { trackPageView } from './utils/analytics';

// Standalone App for subdomain (app.localhost)
function AppConfirmation() {
  useEffect(() => {
    // Track page view for analytics
    trackPageView(window.location.pathname, 'Booking Confirmation');
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/booking/:bookingId" element={<BookingConfirmation />} />
          <Route path="/:bookingId" element={<BookingConfirmation />} />
        </Routes>
      </div>
    </Router>
  );
}

export default AppConfirmation;
